import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadBoardObjectsOperation = 'ReadBoardObjectsV3'

export type ReadBoardObjectsResponse = OpalApiResponseDocument<
  ReadBoardObjectsOperation,
  200
>

export async function readBoardObjects(
  params: OpalApiRequestParams<ReadBoardObjectsOperation>
): Promise<ReadBoardObjectsResponse> {
  const url = new URL(`/board_objects/v3/`, window.location.origin)

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
